// Vendors
import React, { useState } from 'react';
import InputMask from 'react-input-mask';

const EditProjectForm = ({
  projectData,
  unreadMessages,
  requiredFieldsOK,
  epatFieldsOK,
  isNewProject,
  handleInputChange,
  handleChangeView,
  completionDateWrong
}) => {
  const {
    construction_type,
    address,
    city,
    state,
    zipcode,
    completion_date,
    document_gas,
    appliance_total_incentives
  } = projectData;
  const [openAccordion, setOpenAccordion] = useState(false);
  const allStates = window.wlUSStates;

  const areAllGasFieldsComplete = () => {
    const {
      gas_rep_company_name,
      gas_rep_representative,
      gas_rep_city,
      gas_rep_state
    } = projectData;

    return (
      gas_rep_company_name &&
      gas_rep_representative &&
      gas_rep_city &&
      gas_rep_state &&
      document_gas &&
      document_gas != '0'
    );
  };

  const disabled = projectData.status === 'Inactive' ? 'disabled' : '';

  const handleToggleBasicAccordion = () => setOpenAccordion(!openAccordion);

  const getProjectBasicInfoFields = () => {
    return (
      <>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__radio">
              <input
                type="radio"
                name="construction_type"
                value="New"
                checked={construction_type === 'New'}
                onChange={(event) => handleInputChange(event)}
              />
              New Construction
            </label>
            <label className="form__radio">
              <input
                type="radio"
                name="construction_type"
                value="Remodel"
                checked={construction_type === 'Remodel'}
                onChange={(event) => handleInputChange(event)}
              />
              Remodel
            </label>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Address</label>
            <input
              type="text"
              name="address"
              className="form__input"
              value={address}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">City</label>
            <input
              type="text"
              name="city"
              className="form__input"
              value={city}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">State</label>
            <div className="form__select form__select--lg form__input--no-shadow">
              <select
                name="state"
                className="form__input form__input--lg"
                value={state}
                onChange={(event) => handleInputChange(event)}
              >
                <option value="">-- Please select state --</option>
                {allStates &&
                  Object.keys(allStates).map((singleState, index) => (
                    <option key={index} value={singleState}>
                      {allStates[singleState]}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Zip</label>
            <InputMask
              type="text"
              name="zipcode"
              className="form__input"
              onChange={(event) => handleInputChange(event)}
              value={zipcode}
              mask="99999"
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div
            className={`form__field form__field--required ${
              completionDateWrong ? 'form__field--error' : ''
            }`}
          >
            <label className="form__label u--font-weight-bold">
              Expected Completion Date (MM/DD/YYYY)
            </label>
            <InputMask
              type="text"
              name="completion_date"
              className="form__input"
              placeholder="MM/DD/YYYY"
              value={completion_date}
              onChange={(event) => handleInputChange(event)}
              mask="99/99/9999"
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div id="add-project">
      <div className="grid u--font-size-lg" style={{ maxWidth: '600px' }}>
        {isNewProject === false ? (
          <div className="grid__col-xs-12 u--margin-bottom-20">
            <button
              className={`btn btn--outline btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
                openAccordion ? 'btn--pip-accordion--on' : ''
              } ${requiredFieldsOK ? 'btn--pip-complete' : ''}`}
              type="button"
              onClick={() => handleToggleBasicAccordion()}
              disabled={disabled}
            >
              <span className="btn__content">
                <span className="btn__text">Basic Info</span>
                <span className="btn__arrow"></span>
              </span>
            </button>

            <div
              className={
                openAccordion
                  ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
                  : 'u--display-none'
              }
            >
              {getProjectBasicInfoFields()}
            </div>
          </div>
        ) : (
          getProjectBasicInfoFields()
        )}

        {isNewProject === false && (
          <>
            <div className="grid__col-xs-12 u--margin-bottom-20">
              <button
                id="pip-add__appliances"
                className={`btn btn--outline btn--block btn--lg btn--has-arrow module-hover-root ${
                  appliance_total_incentives &&
                  appliance_total_incentives !== '0'
                    ? 'btn--pip-complete'
                    : ''
                }`}
                onClick={() => handleChangeView('appliances')}
                disabled={disabled}
              >
                <span className="btn__content">
                  <span className="btn__text">Appliances</span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
            <div className="grid__col-xs-12 u--margin-bottom-20">
              <button
                id="pip-add__gas-check"
                className={`btn btn--outline btn--block btn--lg btn--has-arrow module-hover-root ${
                  areAllGasFieldsComplete() === true ? 'btn--pip-complete' : ''
                }`}
                disabled={
                  projectData.status === 'Inactive'
                    ? 'disabled'
                    : !requiredFieldsOK
                }
                onClick={() => handleChangeView('document-gas')}
              >
                <span className="btn__content">
                  <span className="btn__text">Gas Check</span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
            <div className="grid__col-xs-12 u--margin-bottom-30">
              <button
                id="pip-add__epat"
                className={`btn btn--outline btn--block btn--lg btn--has-arrow module-hover-root ${
                  epatFieldsOK() ? 'btn--pip-complete' : ''
                }`}
                disabled={
                  projectData.status === 'Inactive'
                    ? 'disabled'
                    : !requiredFieldsOK
                }
                onClick={() => handleChangeView('document-epat')}
              >
                <span className="btn__content">
                  <span className="btn__text">EPAT</span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
            <div className="grid__col-xs-12 u--margin-bottom-0">
              <button
                id="pip-add__epat"
                className="btn btn--outline btn--block btn--lg btn--has-arrow module-hover-root"
                onClick={() => handleChangeView('messages')}
              >
                <span className="btn__content">
                  <span className="btn__text">
                    Project Messages
                    {unreadMessages > 0 && (
                      <span className="btn__text--message-count">
                        {unreadMessages}
                      </span>
                    )}
                  </span>
                  <span className="btn__arrow arrow arrow--black"></span>
                </span>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default EditProjectForm;
